export default __webpack_public_path__ + "static/home-page-1-615028e6d5a5b3732cda77054b7fc794.png";